import React from 'react';
import { makeRoute, gtmSend, generateDomainNewsUrl, generateDomainCommunityUrl } from '../../helpers';
import { Icon } from '../Common/Icon';

import cx from '../../styles';
import { isBeYeuTemplate } from '../../config'

const NavigationHeader = (props) => {
    const t = props.t;
    const iconColorActive = '#FF6464';
    const iconColor = '#888';

    const checkIfActive = (path, url) => {
        const currentLocation = url;
        if (path == '/' && currentLocation == '/') {
            return "active";
        } else if(currentLocation == '/feed/poll' && path == '/feed'){
            return "";
        } else {
            return path != '/' && currentLocation.indexOf(path) > -1 ? "active" : "";
        }
    }

    return (
        <nav className={cx("navigation-header-wrapper")}>
            <ul>
                <li>
                    <div 
                        onClick={() => {gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'tools'); props.handleLeftSlideOpen('tools');}}
                    >
                        <Icon color={iconColor} name={isBeYeuTemplate ? 'beyeu-tools-icon' : 'tools-icon'} />
                        <span>{t('tools')}</span>
                    </div>
                </li>
                <li>
                    {
                      isBeYeuTemplate ?
                      <a
                          href={generateDomainCommunityUrl({country: props.appReducer.country, slug: 'topics'})}
                          onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'article')}
                      >
                          <Icon name={isBeYeuTemplate ? 'beyeu-article-icon' : 'article-icon'} color={iconColor} />
                          <span>{t('community_tab_topic')}</span> 
                      </a>
                      :
                        <a
                            href={generateDomainNewsUrl({country: props.appReducer.country})}
                          onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'article')}
                      >
                          <Icon name={isBeYeuTemplate ? 'beyeu-article-icon' : 'article-icon'} color={iconColor} />
                          <span>{t('articles')}</span>
                      </a>
                    }
                </li>
                {/*<li>
                    <Link 
                        to={makeRoute('/recipes', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'recipes')}
                        className={cx(checkIfActive('/recipes', props.match.url))}
                    >
                        <Icon name='recipes-icon' color={checkIfActive('/recipes', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('recipes')}</span>
                    </Link>
                </li>*/}
                <li className={`pregnancy-icon-warp`}>
                    {
                        props.appReducer.country !== 'sg'
                        ?
                            <a 
                                href={makeRoute('/tracker', props.appReducer)} 
                                onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'tracker')}
                                className={cx(checkIfActive('/tracker', props.match.url) ? 'tracker-active' : '')}
                                aria-label="Go to Pregnancy tracker page"
                            >
                                {
                                    props.match.url.includes('/tracker/baby')
                                    ?
                                        <Icon color={iconColorActive} name={isBeYeuTemplate ? 'beyeu-baby-icon-selected' : 'baby-icon-selected'} />
                                    :
                                        <Icon color={iconColor} name={isBeYeuTemplate ? 'beyeu-pregnancy-icon-selected' : 'pregnancy-icon-selected'} />
                                }
                            </a>
                        :
                            <a 
                                href={`https://sg.theasianparent.com/pregnancy`} 
                                onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'tracker')}
                                className={cx(checkIfActive('pregnancy', props.match.url) ? 'tracker-active' : '')}
                                aria-label="Go to Pregnancy tracker page"
                            >
                                {
                                    props.match.url.includes('/tracker/baby')
                                    ?
                                        <Icon width={'42px'} name={isBeYeuTemplate ? 'beyeu-baby-icon-selected' : 'baby-icon-selected'} />
                                    :
                                        <Icon width={'42px'} name={isBeYeuTemplate ? 'beyeu-pregnancy-icon-selected' : 'pregnancy-icon-selected'} />
                                }
                            </a>
                    }
                </li>
                <li>
                    <a 
                        href={makeRoute('/feed', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'feed')}
                        className={cx(checkIfActive('/feed', props.match.url))}
                    >
                        {
                            checkIfActive('/feed', props.match.url)
                            ?
                                <Icon color={iconColorActive} name={isBeYeuTemplate ? 'beyeu-feed-icon-active' : 'feed-icon'} />
                            :
                                <Icon color={iconColor} name={isBeYeuTemplate ? 'beyeu-feed-icon' : 'feed-icon'} />
                        }
                        <span>{t('menu_feed')}</span>
                    </a>
                </li>
                {/*<li>
                    <Link 
                        to={makeRoute('/contests', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'contests')}
                        className={cx(checkIfActive('/contests', props.match.url))}
                    >
                        <Icon name='contest-icon' color={checkIfActive('/contests', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('contest_title')}</span>
                    </Link>
                </li>*/}
                <li>
                    <a 
                        href={makeRoute('/poll', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'poll')}
                        className={cx(checkIfActive('/poll', props.match.url))}
                    >
                        {
                            checkIfActive('/poll', props.match.url)
                            ?
                                <Icon color={iconColorActive} name={isBeYeuTemplate ? 'beyeu-poll-icon-active' : 'poll-icon'} />
                            :
                                <Icon color={iconColor} name={isBeYeuTemplate ? 'beyeu-poll-icon' : 'poll-icon'} />
                        }
                        <span>{t('community_tab_poll')}</span>
                    </a>
                </li>
                {/*<li>
                    <Link 
                        to={makeRoute('/food', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'food')}
                        className={cx(checkIfActive('/food', props.match.url))}
                    >
                        <Icon name='food-icon' color={checkIfActive('/food', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('food')}</span>
                    </Link>
                </li>*/}

                {/* <li>
                    <Link to={makeRoute('/booth', props.appReducer)} onClick={() => handleGTMEvent('Photo')} className={cx(checkIfActive('/booth', props.match.url))}>
                        <Icon name='photo-icon' color={checkIfActive('/booth', props.match.url) ? '#FF6464' : iconColor} />
                        {t('community_tab_booth')}
                    </Link>
                </li> */}
            </ul>
        </nav>
    );
}

export default NavigationHeader;